import { NgModule } from '@angular/core';
import {
  DateAdapter,
  MatButtonModule,
  MatCardModule, MatCheckboxModule, MatDatepickerModule,
  MatDialogModule,
  MatGridListModule,
  MatIconModule, MatInputModule, MatMenuModule, MatNativeDateModule,
  MatPaginatorModule,
  MatTableModule
} from '@angular/material';
import { CommonModule } from '@angular/common';
import { FormsModule} from '@angular/forms';
import { SharedModule } from './shared/shared.module';
import { CustomDateAdapter } from './shared/adapters/custom-date.adapter';


@NgModule({
  declarations: [
    //
  ],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    MatIconModule,
    MatGridListModule,
    MatMenuModule,
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
    MatCardModule,
    MatTableModule,
    MatPaginatorModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatNativeDateModule
  ],
  entryComponents: [/*PurchaseSelectDialogComponent, CodesSelectDialogComponent*/],
  providers: [
    {
      provide: DateAdapter, useClass: CustomDateAdapter
    },
  ],
})
export class MaterialModule { }
